import sumBy from 'lodash/sumBy';

export const cartQuantity = state => sumBy(state.cart.items, 'quantity');